export const SET_STATE = 'hotelPagePackageInfo/SET_STATE';
export const SET_CURRENT = 'hotelPagePackageInfo/SET_CURRENT';
export const RESET_STATE = 'hotelPagePackageInfo/RESET_STATE';
